module.exports = __webpack_public_path__ + "assets/2f5b65d53dc67d9f2076d00291b1fe13.png";